import { ICD10List } from "../(v2)/components/ICD10List";

type SignatureFieldsProps = {
  note: {
    ICD_10_axis_1_diagnosis?: unknown[];
    ICD_10_axis_2_diagnosis?: unknown[];
  };
};

export function SignatureFields({ note }: SignatureFieldsProps) {
  return (
    <>
      <div className="col-12 col-lg-6 mt-3">
        <div>
          <label className="Label">ICD-10 Primary Diagnosis</label>
          <div>
            {note.ICD_10_axis_1_diagnosis ? (
              <ul>
                <ICD10List data={note.ICD_10_axis_1_diagnosis} />
              </ul>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-6 mt-3">
        <div>
          <label className="Label">ICD-10 Secondary Diagnosis</label>
          <div>
            {note.ICD_10_axis_2_diagnosis ? (
              <ul>
                <ICD10List data={note.ICD_10_axis_2_diagnosis} />
              </ul>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
}
